import angular from "angular";

let PopUpListController = function (
  PopUp,
  $mdDialog,
  $filter,
  $scope,
  $state,
  State,
  City,
  Toast
) {
  let $ctrl = this;
  $ctrl.$scope = $scope;
  angular.extend($ctrl, {
    getRegionsListName,
    onChangeFilter,
    onChangeState
  });

  activate();

  function activate() {
    State.index({ limit: 10000000000 }).then((result)=>{
      $ctrl.states = result;
    })

    $ctrl.states = []
    $ctrl.cities = []
    $ctrl.filterName = ""
    $ctrl.filterCityName = ""
    $ctrl.selectedRegion = ""
    $ctrl.filter = {
      status: null,
      state_id: [],
      city_id: [],
      title: "",
      page: 1,
      total: 0,
    }
    $ctrl.statusList = [
      {
        value: true,
        label: 'Habilitado'
      }
    ]
    $ctrl.uiState = "LOADING";

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: "updated_at",
    };

    $ctrl.$scope.$watch(
      "tableConfig",
      () => {
        $ctrl.loadData();
      },
      true
    );
  }

  function getRegionsListName(group){
    let newList = []
    group.forEach(item => {
      item.regions.forEach(region => {
        newList.push(`${region.name} - ${item.state}`)
      })
    })

    return newList.join(", ")
  }

  function onChangeFilter (){
    $ctrl.loadData()
    onChangeState($ctrl.filter.state_id)
  }

  function onChangeCityFilter (){
    $ctrl.loadData()
  }

  function onChangeState(stateIdArr) {
    if (stateIdArr.length !== 0) {
      $ctrl.filter.city_id = [];
      City.index({
        state_id: stateIdArr,
        limit: 1000000,
      })
        .then((cities) => {
          $ctrl.cities = cities;
        })
        .catch((err) => {
          console.log("err:", err);
          $ctrl.loadingCities = false;
        })
        .finally(() => {
          angular
            .element(document.querySelector(".input-search-city"))
            .on("keydown", function (ev) {
              ev.stopPropagation();
            });
        });
    }
  }

  function DialogController($scope, $mdDialog) {
    "ngInject";
    $scope.loadingText = "Carregando";
    $scope.notification = {
      version: $ctrl.notification.version,
      platform: $ctrl.notification.platform,
      isForced: $ctrl.notification.isForced,
    };

    $scope.hide = function () {
      angular.element(document.querySelector("#fileInput")).val(undefined);
      $mdDialog.hide();
    };

    $scope.cancel = function () {
      angular.element(document.querySelector("#fileInput")).val(undefined);
      $mdDialog.cancel();
    };

    $scope.save = function (resource) {
      $mdDialog.hide(resource);
    };
  }

  // Local functions

  $ctrl.loadData = function () {
    $ctrl.promise = PopUp.getpopUpsList($ctrl.filter)
      .then((response) => {
        $ctrl.resources = angular.copy(response);
        $ctrl.filter.page = response.page
        $ctrl.filter.total = response.total
        $ctrl.uiState = response.data.length ? "COMPLETE" : "EMPTY";
      })
      .catch((err) => {
        $ctrl.uiState = "ERROR";
      });
  }

  function getRegionsList() {
    $ctrl.uiState = "LOADING"
    $ctrl.promise = PopUp.getRegionsList()
      .then((response) => {
        response.forEach(item => {
          item.regions.forEach(region => {
            $ctrl.regionsList.push({name: `${region.name} - ${item.state}`, id: region.id})
          })
          $ctrl.uiState = response.data.length ? "COMPLETE" : "EMPTY";
        })
      })
      .catch((err) => {
        $ctrl.uiState = "ERROR";
      });
  }

  function saveData(resource) {
    $ctrl.promise = PopUp.save(resource)
      .then((response) => {
        $ctrl.loadData();
      })
      .catch((err) => {
        $ctrl.uiState = "ERROR";
      })
      .finally(() => {
        $ctrl.notification = {
          version: null,
          plataform: "",
          isForced: false,
        };
      });
  }

  $ctrl.deletePopUp = function (popUp) {
    let confirm = $mdDialog.confirm()
      .textContent(`Remover pop-up "${popUp.title}"`)
      .ariaLabel(`Remover pop-up "${popUp.title}"`)
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        PopUp
          .destroy(popUp)
          .then(response => {
            Toast.success($filter('translate')('common-detail-delete-success'));
            $ctrl.loadData()
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
          });
      })
      .catch(() => {
      });
  }

  $ctrl.detail = function(id) {
    $state.go('pop-up.detail', {id});
  }
};

PopUpListController.$inject = [
  "PopUp",
  "$mdDialog",
  "$filter",
  "$scope",
  "$state",
  "State",
  "City",
  "Toast",
];

export default PopUpListController;



// WEBPACK FOOTER //
// ./client/app/components/pop-up/pop-up-list.controller.js